/* ===== „Refă pagina cu Joy” = de la zero, dar pagina veche rămâne live până la final =====
 * Cât timp refaci pagina (ai.fresh), ce completezi se ține în draft (ai.pending), nu în pagina publică.
 * Abia la „Salvează” pagina veche se golește și se pune cea nouă.
 * Campania și fidelizarea nu se golesc (se aleg la pasul 6).
 */

export const FRESH_WIPE = {
  bgURLs: [],
  locationLogoURL: null,
  locationMapName: '',
  clientTagline: '',
  socialMedia: {
    facebook: { enabled: false, link: '', qrUrl: '' },
    instagram: { enabled: false, link: '', qrUrl: '' },
    tiktok: { enabled: false, link: '', qrUrl: '' }
  },
  clientSocialUrl: '',
  reservationPhone: '',
  reservationEnabled: false,
  locationMapUrl: '',
  locationMapAddress: '',
  locationMapEnabled: false,
  locationHoursImageURL: null,
  locationHoursEnabled: false,
  wifiSsid: '',
  wifiPassword: '',
  wifiEnabled: false,
  clientFeedbackUrl: '',
  feedbackEnabled: false,
  menuUrl: '',
  menuImages: [],
  menuEnabled: false,
  clientPromoGallery: { enabled: false, title: '', images: [] }
};

export function isFresh(ai) {
  return !!ai && ai.fresh === true;
}

/** Setările așa cum arată pagina nouă (golită + ce ai completat până acum). */
export function freshView(settings, ai) {
  const s = settings || {};
  if (!isFresh(ai)) return s;
  return { ...s, ...FRESH_WIPE, bgURL: '', ...(ai.pending || {}) };
}

/** Pune pagina nouă peste obiectul de setări din memorie (doar pentru previzualizare). */
export function overlayFreshInMemory(settings, ai) {
  if (!settings || !isFresh(ai)) return;
  Object.assign(settings, FRESH_WIPE, { bgURL: '' }, ai.pending || {});
}

/** Ce se salvează la final: golim tot, apoi punem ce ai completat. */
export function freshFinalPatch(ai) {
  return { ...FRESH_WIPE, ...((ai && ai.pending) || {}) };
}
